module.exports = __webpack_public_path__ + "assets/img/s3-tab-4-60c2a761.png";